import React, { useState, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import { getDecryptedAccessToken, getDecryptedUserType } from "../../../Utils/LoginUserDetails.js/LoginUserSavedDetails";
import {
  Box, Button, TextField, Snackbar, Alert, CircularProgress, Grid, Card, CardMedia, IconButton, Dialog, DialogTitle
} from "@mui/material";
import PhotoCameraIcon from "@mui/icons-material/PhotoCamera";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import DownloadIcon from "@mui/icons-material/Download";
import CloseIcon from "@mui/icons-material/Close";
import ReactWebcam from "react-webcam";
import ApiServices from "../../../Utils/ApiServices/ApiServices";

const ServicesImages = ({imageType,service,getnewData,appointmentData}) => {
  console.log("service",service)
  const params = useParams();
  const accessToken = getDecryptedAccessToken();
  const LoginUserType = getDecryptedUserType();
  const [imageFile, setImageFile] = useState(null);
  const [capturedImage, setCapturedImage] = useState(null);
  const [loading, setLoading] = useState(false);
  const [images, setImages] = useState([]);
  const [openSnackbar, setOpenSnackbar] = useState({ open: false, message: "", severity: "" });
  const [previewOpen, setPreviewOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const webcamRef = useRef(null);
  const pid = params.pid || appointmentData?.pc_pid;
  const eid = params.eid || appointmentData?.pc_eid;

  useEffect(() => {
    fetchServiceImages();
  }, [pid, eid]);

  const fetchServiceImages = async () => {
    const endpoint =
    LoginUserType === "Patient"
    ? `/apis/default/portal/getServiceImages/${service.service_no}/appointment/${eid}`
    : `/apis/default/api/getServiceImages/${service.service_no}/appointment/${eid}`;
    try {
      const response = await ApiServices.get(endpoint, {
        Authorization: `Bearer ${accessToken}`
      });
  
      // Filter images based on imageType
      const filteredImages = response.data.filter(img => 
        imageType === "Pre-Treatment Image" ? img.image_type.startsWith("pretreatment") : 
        imageType === "Post-Treatment Image" ? img.image_type.startsWith("posttreatment") : 
        false
      );
  
      setImages(filteredImages);
    } catch (error) {
      console.error("Error fetching images:", error);
    }
  };
  
  // ✅ Capture Image from Webcam
  const captureImage = () => {
    const imageSrc = webcamRef.current.getScreenshot();
    setCapturedImage(imageSrc);
  };

  const uploadImage = async () => {
    if ((!imageFile && !capturedImage)) {
      setOpenSnackbar({ open: true, message: "Please provide an image name and select an image!", severity: "error" });
      return;
    }
  
    setLoading(true);
    let base64Image = capturedImage; // If captured, already Base64
  
    if (imageFile) {
      const reader = new FileReader();
      reader.readAsDataURL(imageFile);
      reader.onloadend = async () => {
        base64Image = reader.result; // Convert file to Base64
        await sendImageToServer(base64Image);
      };
    } else {
      await sendImageToServer(base64Image);
    }
  };
  
  const sendImageToServer = async (base64Image) => {
   
  
    const formattedImageType = `${imageType === "Pre-Treatment Image" ? "pretreatment_front" : "posttreatment_front"}`;
  
    const payload = {
      eid,
      pid,
      service_id: service.service_no,
      image_type: formattedImageType,
      treatment_image: base64Image
    };
    const endpoint =
        LoginUserType === "Patient"
          ? `/apis/default/portal/saveServiceImage`
          : `/apis/default/api/saveServiceImage`;
  
    try {
      await ApiServices.post(endpoint, payload, {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json"
      });
  
      setOpenSnackbar({ open: true, message: "Image uploaded successfully!", severity: "success" });
      setImageFile(null);
      setCapturedImage(null);
      fetchServiceImages(); 
      getnewData()
    } catch (error) {
      setOpenSnackbar({ open: true, message: "Upload failed. Try again!", severity: "error" });
      console.error("Upload Error:", error);
    } finally {
      setLoading(false);
    }
  };
  
  

  // ✅ Handle Image Download
  const downloadImage = async (imageUrl) => {
    const link = document.createElement("a");
    link.href = imageUrl;
    link.download = imageUrl.split("/").pop();
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <Box p={3}>
      <h2>Upload Service Image</h2>

    
      {/* Capture Image from Camera */}
      <Box display="flex" alignItems="center" gap={2} mb={2}>
        <Button variant="contained" startIcon={<PhotoCameraIcon />} onClick={captureImage}>
          Capture Image
        </Button>
        <ReactWebcam ref={webcamRef} screenshotFormat="image/jpeg" width={100} height={100} />
      </Box>

      {/* Upload Image from Local */}
      <input
        type="file"
        accept="image/*"
        onChange={(e) => setImageFile(e.target.files[0])}
        style={{ marginBottom: 10 }}
      />

      {/* Preview Selected Image */}
      {capturedImage && <img src={capturedImage} alt="Captured" width={200} />}
      {imageFile && <img src={URL.createObjectURL(imageFile)} alt="Selected" width={200} />}

      {/* Upload Button */}
      <Button
        variant="contained"
        color="primary"
        startIcon={<CloudUploadIcon />}
        onClick={uploadImage}
        disabled={loading}
        sx={{ mt: 2 }}
      >
        {loading ? <CircularProgress size={24} /> : "Upload"}
      </Button>

      {/* Service Images Gallery */}
      <h2>Service Images</h2>
      {images.length === 0 ? (
        <p>No images available</p>
      ) : (
        <Grid container spacing={2}>
          {images.map((img) => (
            <Grid item key={img.id} xs={12} sm={6} md={4} lg={3}>
              <Card>
                <CardMedia
                  component="img"
                  height="200"
                  image={img.image_url.replace("/var/www/html", "http://18.191.236.218")}
                  alt="Service Image"
                  onClick={() => {
                    setSelectedImage(img.image_url.replace("/var/www/html", "http://18.191.236.218"));
                    setPreviewOpen(true);
                  }}
                  sx={{ cursor: "pointer" }}
                />
                <Box textAlign="center" p={1}>
                  <IconButton onClick={() => downloadImage(img.image_url.replace("/var/www/html", "http://18.191.236.218"))}>
                    <DownloadIcon />
                  </IconButton>
                </Box>
              </Card>
            </Grid>
          ))}
        </Grid>
      )}

      {/* Image Preview Dialog */}
      <Dialog open={previewOpen} onClose={() => setPreviewOpen(false)}>
        <DialogTitle>
          <IconButton onClick={() => setPreviewOpen(false)} sx={{ position: "absolute", right: 10 }}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        {selectedImage && <img src={selectedImage} alt="Preview" width="100%" />}
      </Dialog>

      {/* Snackbar for Success/Error Messages */}
      <Snackbar open={openSnackbar.open} autoHideDuration={3000} onClose={() => setOpenSnackbar({ ...openSnackbar, open: false })}>
        <Alert severity={openSnackbar.severity} sx={{ width: "100%" }}>
          {openSnackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default ServicesImages;
